<template>
  <div id="berandaguru">
    <h1 class="title is-4">Data Guru</h1>

    <div id="navbar">
      <b-navbar class="has-background-white-ter" style="margin-right: 8px">
        <!-- <template slot="brand">
        </template> -->
        <template slot="start">
          <b-button
            class="button is-success"
            tag="router-link"
            to="/biro/dataguru"
            @click="tambahData()"
            rounded
            icon-left="account-plus"
            >Tambah Guru</b-button
          >
        </template>
        <template slot="end">
          <div class="columns">
            <div class="column">
              <b-select v-model="filter" placeholder="Filter by Paket">
                <option value="All">Semua</option>
                <option value="CT-1">Computational Thinking 1</option>
                <option value="CT-2">Computational Thinking 2</option>
                <option value="CT-Advanced">Computational Thinking Advanced</option>
                <option value="INF">Informatika</option>
              </b-select>
            </div>
            <div class="column">
              <b-field position="is-centered">
                <b-input
                  placeholder="Search By Name and Email"
                  type="search"
                  v-model="search"
                  icon="magnify">
                </b-input>
              </b-field>
            </div>
          </div>
        </template>
      </b-navbar>
    </div>

    <div class="card py-16 px-16">
      <section>
        <b-table
          :data="filteredList"
          bordered
          striped
          narrowed
          hoverable
          :loading="isLoading"
          :mobile-cards="true"
          ref="table"
          paginated
          :per-page="perPage"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          :opened-detailed="defaultOpenedDetails"
          detailed
          detail-key="id_guru"
          @details-open="
            (row) => $buefy.toast.open(`Show Detail ${row.nama_guru}`)
          "
          :show-detail-icon="showDetailIcon"
        >
          <b-table-column
            field="index"
            label="No"
            width="40"
            numeric
            v-slot="props"
          >
            {{ props.row.index }}
          </b-table-column>
          <b-table-column
            field="id_guru"
            label="ID Guru"
            :visible="false"
            sortable
            v-slot="props"
          >
            {{ props.row.id_guru }}
          </b-table-column>
          <b-table-column
            field="nama_guru"
            label="Nama Guru"
            sortable
            v-slot="props"
          >
            {{ props.row.nama_guru }}
          </b-table-column>
          <!-- <b-table-column field="jenis_kelamin" label="Jenis Kelamin" sortable v-slot="props">
                {{ props.row.jenis_kelamin }}
            </b-table-column> -->
          <b-table-column
            field="no_handphone"
            label="No Handphone"
            sortable
            v-slot="props"
          >
            {{ "+62" + props.row.no_handphone }}
          </b-table-column>
          <b-table-column field="email" label="Email" sortable v-slot="props">
            {{ props.row.email }}
          </b-table-column>
          <b-table-column
            field="nama_sekolah"
            label="Asal Sekolah"
            sortable
            v-slot="props"
          >
            {{ props.row.nama_sekolah }}
          </b-table-column>
          <b-table-column
            field="jenis_paket"
            label="Jenis Paket"
            sortable
            v-slot="props"
          >
            {{ props.row.jenis_paket }}
          </b-table-column>

          <template slot="bottom-left">
            <div class="columns">
              <div class="column">
                <b-field horizontal label="Row">
                  <b-select v-model="perPage">
                    <!-- <option value="5">5 Per Page</option> -->
                    <option value="10">10 Per Page</option>
                    <option value="30">30 Per Page</option>
                    <option value="50">50 Per Page</option>
                  </b-select>
                </b-field>
              </div>
            </div>
          </template>

          <template #detail="props">
            <article class="media">
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ props.row.nama_guru }}</strong>
                    <br />
                    <small><b>Jenis Kelamin : </b>{{ props.row.jenis_kelamin }}</small>
                    <br />
                    <small><b>NUPTK : </b>{{ props.row.nuptk }}</small>
                    <br />
                    <small><b>Tanggal Lahir </b>{{ props.row.tgl_lahir }}</small>
                    <br />
                    <small><b>Mata Pelajaran : </b>{{ props.row.mata_pelajaran }}</small>
                    <br />
                    <!-- <small><b>Nama Regu : </b> {{ props.row.nama_regu }}</small>
                    <br /> -->
                    <!-- <small><b>Jenis Guru : </b>{{ props.row.jenis_guru }}</small>
                    <br /> -->
                    <small><b>Jabatan : </b>{{ props.row.jabatan }}</small>
                    <br />
                    <small><b>Nomor Paket : </b>{{ props.row.nomor_paket }}</small>
                    <br />
                    <small><b>Nomor Urut : </b>{{ props.row.nomor_urut }}</small>
                    <br />
                    <!-- <small><b>Jenis Paket : </b>{{props.row.jenis_paket}}</small> -->
                  </p>
                </div>
              </div>
            </article>
          </template>

          <b-table-column label="Action" v-slot="props">
            <span>
              <b-dropdown aria-role="list" position="is-bottom-left">
                <b-icon icon="dots-vertical" slot="trigger"></b-icon>
                <b-dropdown-item aria-role="listitem">
                  <b-button
                    tag="router-link"
                    style="height: 30px"
                    expanded
                    icon-left="pencil"
                    type="is-info"
                    :to="'/biro/dataguru/' + props.row.id_guru"
                    >Edit
                    <!-- <b-icon icon="pencil" type="is-info"></b-icon> -->
                  </b-button>
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem">
                  <b-button
                    expanded
                    icon-left="delete"
                    type="is-danger"
                    style="height: 30px"
                    @click="confirmDelete(props.row.id_guru)"
                    >Hapus
                    <!-- <b-icon icon="delete" type="is-danger"></b-icon> -->
                  </b-button>
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem">
                  <!-- <b-button type="button is-success" expanded icon-left="download" style="height:30px;"
                        @click="cetakSertifikat(props.row.id_guru)">Sertifikat
                      </b-button> -->
                  <b-button
                    type="button is-success"
                    expanded
                    icon-left="download"
                    style="height: 30px"
                    @click="openDialogCetakSertifikat(props.row.id_guru)"
                    >Sertifikat
                  </b-button>
                </b-dropdown-item>
                <!-- <b-dropdown-item aria-role="listitem">
                      <b-button expanded
                      icon-left="download"
                      type="is-warning"
                      style="height:30px"
                      id="login"
                      @click="openDialogSertifikat = true">Assign Paket
                      </b-button>
                      <b-modal
                        v-model="openDialogSertifikat"
                        has-modal-card
                        trap-focus
                        :destroy-on-hide="false"
                        aria-role="dialog"
                        aria-modal
                      >
                      <template #default="props">
                        <modal-form
                          @close="props.close"
                          @netralizeCheckbox="netralize(formProps.checkbox)"
                          @save="save()"
                          @reset="resetForm()"
                        >
                        </modal-form>
                      </template>
                    </b-modal>
                    </b-dropdown-item> -->
              </b-dropdown>
            </span>
          </b-table-column>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <!-- <p>
                    <b-icon
                    :icon ="tableLoadingIcon"
                    size="is-large">
                    </b-icon>
                  </p> -->
                <p>{{ tableMessage }}</p>
              </div>
            </section>
          </template>
        </b-table>
      </section>
    </div>

    <b-modal
      :active.sync="openDialogSertifikat"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card py-16 px-16" style="width: auto">
        <div class="modal-card-head">
          <p class="modal-card-title has-text-centered">Download Sertifikat</p>
          <button
            type="button"
            class="delete"
            @click="openDialogSertifikat = false"/>
        </div>
        <div class="modal-card-body">
          <b-table
            :data="allSertifikat"
            bordered
            striped
            narrowed
            hoverable
            :loading="isLoadingSertifikat"
            :mobile-cards="true"
            ref="table"
            paginated
            :per-page="perPage"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <b-table-column
              field="index"
              label="No"
              width="40"
              numeric
              v-slot="props"
            >
              {{ props.row.index }}
            </b-table-column>
            <b-table-column
              field="id_sertifikat"
              label="ID Sertifikat"
              :visible="false"
              sortable
              v-slot="props"
            >
              {{ props.row.id_sertifikat }}
            </b-table-column>
            <b-table-column
              field="jenis_paket"
              label="Jenis Paket"
              sortable
              v-slot="props"
            >
              {{ namaPaket(props.row.jenis_paket) }}
            </b-table-column>
            <b-table-column
              field="periode_pelaksanaan"
              label="Periode Pelaksanaan"
              sortable
              v-slot="props"
            >
              {{ props.row.periode_pelaksanaan }}
            </b-table-column>
            <b-table-column
              field="nama_koordinator"
              label="Nama Koordinator"
              sortable
              v-slot="props"
            >
              {{ props.row.nama_koordinator }}
            </b-table-column>
            <b-table-column
              field="tanggal_terbit"
              label="Tempat, Tanggal Terbit"
              sortable
              v-slot="props"
            >
              {{
                `${props.row.tempat_terbit}, ${new Date(
                  props.row.tanggal_terbit
                ).toLocaleDateString("id-ID", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}`
              }}
            </b-table-column>

            <template slot="bottom-left">
              <div class="columns">
                <div class="column">
                  <b-field horizontal label="Row">
                    <b-select v-model="perPage">
                      <!-- <option value="5">5 Per Page</option> -->
                      <option value="10">10 Per Page</option>
                      <option value="30">30 Per Page</option>
                      <option value="50">50 Per Page</option>
                    </b-select>
                  </b-field>
                </div>
              </div>
            </template>

            <b-table-column label="Action" v-slot="props">
              <b-button
                :loading="props.row.downloadBtnLoading"
                style="height: 30px"
                expanded
                icon-left="download-circle"
                type="is-info"
                @click="cetakSertifikat(props.row.id_sertifikat)">
                Download
              </b-button>
            </b-table-column>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>{{ tableMessageSertifikat }}</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
var $ = require("jquery");
export default {
  data() {
    return {
      defaultOpenedDetails: [1],
      openDialogSertifikat: false,
      showDetailIcon: true,
      file: null,
      gurus: [],
      perPage: "10",
      guru: {
        nuptk: "",
        nama_guru: "",
        jenis_kelamin: "",
        tgl_lahir: "",
        no_handphone: "",
        email: "",
        mata_pelajaran: "",
        jenis_guru: "",
        nama_sekolah: "",
        nama_regu: "",
      },
      detailId: "",
      //tableLoadingIcon:'sync',
      tableMessage: "Loading...",
      detailOpened: [],
      isLoading: true,
      snackbarMessage: "",
      search: "",
      filter: null,
      // id_biro:'',
      activeUser: Object,
      activeBiro: Object,
      config: {},
      allSertifikat: [],
      isLoadingSertifikat: false,
      tableMessageSertifikat: "Loading...",
      guruID: 0,
      downloadBtnLoading: false,
    };
  },
  computed: {
    filteredList() {
      return this.gurus.filter((guru) => {
        if (this.filter !== null) {
          if (this.filter === 'All') {
            return guru
          } else if (guru.jenis_paket !== null) {
            return guru.jenis_paket.toLowerCase().includes(this.filter.toLowerCase()) && guru.nama_guru.toLowerCase().includes(this.search.toLowerCase());
          }
        } else {
          return guru.nama_guru.toLowerCase().includes(this.search.toLowerCase());
        }
        // guru.email.toLowerCase().includes(this.search.toLowerCase())
      });
    },
  },
  methods: {
    // getData()
    // {
    //   this.isLoading=true
    //   var uri = this.$apiUrl + 'guru'

    //   this.$http.get(uri).then(response =>
    //   {
    //     this.gurus = response.data.value
    //     console.log(this.gurus)
    //     for(var i=0; i<this.gurus.length; i++)
    //     {
    //       this.gurus[i].index = i+1
    //     }
    //    // this.tableLoadingIcon = "emoticon-sad"
    //     this.tableMessage ='Tidak ada data yang sesuai'
    //     this.isLoading=false
    //   })
    //   .catch(error =>{
    //     this.errors = console.error
    //    // this.tableLoadingIcon = "emoticon-sad"
    //     this.tableMessage='Tidak ada Data'
    //     this.isLoading = false
    //   })
    // },
    save() {
      this.$router.push({
        name: "BerandaSertifikat",
      });
    },
    getDataByBiro() {
      this.isLoading = true;
      var uri = this.$apiUrl + "guru/biro/" + this.detailId;
      this.gurus = [];

      this.$http
        .get(uri, this.config)
        .then((response) => {
          this.gurus = response.data.value;
          console.log(this.gurus);
          for (var i = 0; i < this.gurus.length; i++) {
            this.gurus[i].index = i + 1;
            // if(this.gurus[i].tgl_lahir === null){
            //   this.gurus[i].tgl_lahir = '-'
            // }
          }
          this.tableMessage = "Tidak ada data yang sesuai";
          this.isLoading = false;
        })
        .catch((error) => {
          this.errors = console.error;
          this.tableMessage = "Tidak ada Data";
          this.isLoading = false;
        });
    },
    deleteData(deleteID) {
      var uri = this.$apiUrl + "guru/delete/" + deleteID;

      this.$http
        .post(uri, null, this.config)
        .then((response) => {
          this.getDataByBiro();
          this.snackbarMessage = response;
          this.snackbar("Data Berhasil dihapus", "is-success");
        })
        .catch((error) => {
          this.errors = error;
          // this.snackbarMessage = "Silahkan coba hapus lagi"
          this.snackbar(this.snackbarMessage, "is-danger");
          this.snackbar("Silahkan coba lagi", "is-danger");
        });
    },

    namaPaket(value) {
      if (value === "CT-1") {
        return "Computational Thinking 1";
      } else if (value === "CT-2") {
        return "Computational Thinking 2";
      } else if (value === "CT-Advanced") {
        return "Computational Thinking Advanced";
      } else if (value === "INF") {
        return "Informatika";
      }
    },

    async getDataSertifikatByBiro() {
      this.isLoadingSertifikat = true;
      var uri = `${this.$apiUrl}sertifikat/biro/${this.detailId}?id_guru=${this.guruID}`;
      this.allSertifikat = [];

      this.$http
        .get(uri, this.config)
        .then((response) => {
          this.allSertifikat = response.data.value;
          console.log(this.allSertifikat);
          for (var i = 0; i < this.allSertifikat.length; i++) {
            this.allSertifikat[i].index = i + 1;
            this.allSertifikat[i].downloadBtnLoading = false;
          }
          console.log('sertif', this.allSertifikat)
          this.tableMessageSertifikat = "Tidak ada data yang sesuai";
          this.isLoadingSertifikat = false;
        })
        .catch((error) => {
          this.errors = console.error;
          this.tableMessageSertifikat = "Tidak ada sertifikat yang tersedia untuk Guru ini.";
          this.isLoadingSertifikat = false;
        });
    },

    async openDialogCetakSertifikat(id_guru) {
      this.guruID = id_guru;
      await this.getDataSertifikatByBiro();
      this.openDialogSertifikat = true;
    },

    toggleLoading(id_sertifikat, state) {
      this.allSertifikat.map((item) => {
        if (item.id_sertifikat === id_sertifikat) {
          item.downloadBtnLoading = state
        }
      })
      this.$forceUpdate()
    },

    cetakSertifikat(id_sertifikat) {
      this.toggleLoading(id_sertifikat, true)
      this.downloadBtnLoading = true;
      var urlCetak = this.$apiUrl + `cetakGuru/${this.detailId}/${this.guruID}/${id_sertifikat}`;

      this.$http
        .get(urlCetak, {
          headers: {
            Authorization: "Bearer " + this.$session.get("token"),
            "Content-Type": "application/json",
            Accept: "application/pdf",
          },
        })
        .then((response) => {
          let link = document.createElement("a");
          link.href = response.data.value;
          link.download = response.data.file_name;
          link.click();
          this.toggleLoading(id_sertifikat, false)
          this.downloadBtnLoading = false;
          this.snackbar('Sertifikat berhasil diunduh', "is-success");
        })
        .catch((error) => {
          console.log(error);
          this.snackbar(error.response.data.Message, "is-danger");
          this.toggleLoading(id_sertifikat, false)
          this.downloadBtnLoading = false;
        });
    },
    snackbar(message, type) {
      this.$buefy.toast.open({
        duration: 5000, //5 detik
        message: message,
        type: type,
        position: "is-top",
        actionText: "OK",
        queue: false,
      });
    },
    confirmDelete(deleteID) {
      this.$buefy.dialog.confirm({
        title: "Hapus Guru",
        message: "Apa anda yakin ingin menghapus ?",
        confirmText: "Hapus",
        cancelText: "Batal",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteData(deleteID),
      });
    },
  },
  mounted() {
    //this.getData();
    if (this.$session.exists()) {
      this.activeUser = this.$session.get("user");
      this.config = {
        headers: {
          Authorization: "Bearer " + this.$session.get("token"),
        },
      };
    }
    this.activeBiro = this.$session.get("biro");
    if (this.activeBiro) {
      this.detailId = this.activeBiro.id_biro;
      this.getDataByBiro();
    }
  },
};
</script>
<style scoped>
.isikonten {
  font-size: 15px;
  /* padding:0px; */
}
</style>

